module.exports = __webpack_public_path__ + "img/PRprinting6.60267e64.png";